import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { type Sort } from '@angular/material/sort';
import { type IncidentItemDto } from '@api/incidents';
import { IncidentColumn } from '@models';
import { AvsDatagridComponent, DatagridCellDirective } from '@ui';

import { IncidentSeverityIconComponent } from '../../incident-status';
import { buildIncidentsV2GridColumns, type IncidentsV2GridRow, toIncidentsV2GridRows } from '../incidents-v2-table/incidents-v2-grid';
import { sortIncidentRows } from './sort-incident-rows';

export const REPORT_COLUMN_IDS: string[] = [
  IncidentColumn.INDEX,
  IncidentColumn.TICKET_NUMBER,
  IncidentColumn.STATUS,
  IncidentColumn.REPORTED,
  IncidentColumn.RESOLVED,
  IncidentColumn.DEVICE_ID,
  IncidentColumn.DEVICE_TYPE,
  IncidentColumn.BUILDING,
  IncidentColumn.FLOOR,
  IncidentColumn.ROOM,
  IncidentColumn.INCIDENT_RULE,
];

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
  imports: [AvsDatagridComponent, DatagridCellDirective, IncidentSeverityIconComponent],
  selector: 'app-incidents-report-table',
  templateUrl: './incidents-report-table.component.html',
})
export class IncidentsReportTableComponent {
  incidents = input.required<IncidentItemDto[]>();
  noDataText = input('No Results');
  tableId = input<string | null>(null);

  protected readonly columns = buildIncidentsV2GridColumns(false).filter(column => REPORT_COLUMN_IDS.includes(column.id));
  protected readonly columnOrder = REPORT_COLUMN_IDS;
  protected readonly gridSort = signal<Sort>({
    active: '',
    direction: '',
  });
  protected readonly rows = computed(() => sortIncidentRows(this.baseRows(), this.gridSort()));
  private readonly baseRows = computed(() => toIncidentsV2GridRows(this.incidents()));

  protected trackById(_index: number, row: IncidentsV2GridRow) {
    return row.id;
  }
}
